import { useState, useEffect } from "react";

/* eslint-disable react/prop-types */
const Countdown = ({ initialSeconds }) => {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (seconds <= 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  // Formatear minutos:segundos
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return (
    <div className="text-center text-2xl font-bold font-mono uppercase">
      {minutes}:{secs.toString().padStart(2, "0")}
    </div>
  );
};

export default Countdown;
